import { createMutation } from "@steto-care/steto-query";

import { PrescriptionRepository } from "@/io/repository/PrescriptionRepository.ts";
import { GeneratePrescriptionData } from "@/models/PrescriptionGenerationModel.ts";

export class PrescriptionQueries {
  constructor(private readonly prescription: PrescriptionRepository = new PrescriptionRepository()) {}

  /*******************************/
  /*********** Mutation ***********/
  /*******************************/

  useGeneratePrescription = createMutation("generate-prescription", async (data: GeneratePrescriptionData) =>
    this.prescription.generatePrescription(data),
  );

  useSignPrescription = createMutation("sign-prescription", async (data: GeneratePrescriptionData) =>
    this.prescription.signPrescription(data),
  );
}
